import React from "react"
import { useState } from "react";
import VimeoPlayer from "./slice-components/vimeo";

const VideoModal = ({src, tracking, ytId}) => {

    const [isOpen, setIsOpen] = useState(false);

    const toggleOpen = () => {
        if (typeof document !== 'undefined') {
            document.body.classList.toggle('modal-open');
        }
        setIsOpen(true);
    };
    const toggleClose = () => {
        if (typeof document !== 'undefined') {
            document.body.classList.toggle('modal-open');
        }
        setIsOpen(false);
    };

    const escapeCheck = (event) => {
        if (event.key === 'Escape'){
            toggleClose();
        }
      }


    return (
        <>
            <a className={"play hidden lg:block hover:opacity-80 " + (tracking ? tracking : '')} onClick={toggleOpen}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="white" d="M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM196.1 161c2.5-1.4 5.6-1.4 8.1 .2l144 88c2.4 1.5 3.8 4 3.8 6.8s-1.4 5.4-3.8 6.8l-144 88c-2.5 1.5-5.6 1.6-8.1 .2s-4.1-4.1-4.1-7V168c0-2.9 1.6-5.6 4.1-7zm16.4-13.5c-7.4-4.5-16.7-4.7-24.3-.5s-12.3 12.3-12.3 20.9V344c0 8.7 4.7 16.7 12.3 20.9s16.8 4.1 24.3-.5l144-88c7.1-4.4 11.5-12.1 11.5-20.5s-4.4-16.1-11.5-20.5l-144-88z"/></svg>
                </a>
            {isOpen ? <div className="modal-overlay items-center justify-center" onClick={toggleClose}>
                <div className="modal video-m" onKeyDown={escapeCheck}>
                    <div className="close"><i className="fa-solid fa-xmark" /></div>
                    {ytId ? 
                    <iframe width="560" height="315" src={"https://www.youtube.com/embed/" + ytId + "?si=DsxYzoUGr8BEvb22&autoplay=1&mute=0"} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    :
                    <VimeoPlayer videoId={src} autoplay={true} hideControls={true} />}
                </div>
            </div> : ''}

        </>
    )
}

export default VideoModal;